import { useHotkeys } from 'react-hotkeys-hook';

import { useChatSidebarStore } from '@air/feature-ag-ui-chat';

const HOTKEY_OPTIONS = { preventDefault: true };

export function useChatSidebarShortcut() {
  const toggleOpen = useChatSidebarStore((state) => state.toggleOpen);

  useHotkeys('mod+/', toggleOpen, HOTKEY_OPTIONS, [toggleOpen]);
}
